import { Engine } from 'models/Engine/types';
import { DataSource, DataSourceCategory, DataSourceName, DataSources } from './types';

export const getDataSourceColor = (category: DataSourceCategory): string => {
    const map = {
        reporting: '#00D2FF',
        sprinksights: '#F4AF04',
        paid: '#D248A6',
        'content-marketing': '#35C40F',
        twitter: '#1DA1F2',
        default: '#00D2FF',
    };
    return map[category] ?? map.default;
};

export const findDataSourceName = (
    dataSources?: DataSources,
    engine?: Engine,
    sourceGroup?: string
): DataSourceName => {
    if (!dataSources || !engine) {
        console.warn('dataSources and engine not provided');
        return null;
    }
    return Object.values(DataSourceName).find(dsn => {
        if (!dataSources?.[dsn]) {
            return false;
        }
        const dataSource: DataSource = dataSources?.[dsn];
        if (dataSource?.reportingEngine === engine) {
            // check for datasource with defined sourceGroup, then check for match.
            if (dataSource.sourceGroup) {
                return dataSource.sourceGroup === sourceGroup;
            } else {
                return true;
            }
        } else {
            return false;
        }
    });
};
